exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "button.segment-action-button {\n  padding: 6px;\n  flex: 1;\n  align-self: stretch;\n  border-bottom: 1px solid;\n}", ""]);

